import yaml from 'js-yaml';
import Papa from 'papaparse';

export const parseImportedFile = (fileContent, fileExtension) => {
  return new Promise((resolve, reject) => {
    switch (fileExtension) {
      case 'json':
        try {
          const data = JSON.parse(fileContent);
          resolve(data);
        } catch (error) {
          reject(new Error('Invalid JSON file'));
        }
        break;
      case 'yaml':
      case 'yml':
        try {
          const data = yaml.load(fileContent);
          resolve(data);
        } catch (error) {
          reject(new Error('Invalid YAML file'));
        }
        break;
      case 'txt':
        const lines = fileContent.split('\n\n');
        const txtData = lines.map(block => {
          const [title, url] = block.split('\n');
          return { title, url };
        }).filter(item => item.title && item.url);
        resolve(txtData);
        break;
      case 'csv':
        Papa.parse(fileContent, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            resolve(results.data);
          },
          error: (error) => {
            reject(error);
          },
        });
        break;
      default:
        reject(new Error(`Unsupported file type: ${fileExtension}`));
    }
  });
};
